module.exports = __webpack_public_path__ + "static/img/KokiAjir.1a6709b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/classmates/KokiAjir.png
// module id = qg0O
// module chunks = 41